import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { FailedPaymentReceiptGeneration } from "./FailedPaymentReceiptGeneration";


export const DisputeResolution = () => {
  const subheader = useSubheader();
  subheader.setTitle("Dispute Resolution");

  return (
    <>
      <div className="row">
        <div className="col-12">
          <Switch>
            
            <Redirect
              from="/dispute-resolution"
              exact={true}
              to="/dispute-resolution/generate-receipt"
            />
            <Route
              path="/dispute-resolution/generate-receipt"
              component={ FailedPaymentReceiptGeneration }
            />

          </Switch>
      </div>
      </div>
    </>
  );
};
